module.exports = __webpack_public_path__ + "media/PAG88-05.11ba8128.mp3";